import {
  PURCHASE_ORDER_LIST_GET_REQUEST,
  PURCHASE_ORDER_LIST_GET_SUCCESS,
  PURCHASE_ORDER_LIST_GET_FAILURE,
  PURCHASE_ORDER_SEARCH_REQUEST,
  PURCHASE_ORDER_SEARCH_SUCCESS,
  PURCHASE_ORDER_SEARCH_FAILURE,
  PURCHASE_ORDER_DATA_REQUEST,
  PURCHASE_ORDER_DATA_SUCCESS,
  PURCHASE_ORDER_DATA_FAILURE,
  PURCHASE_ORDER_CREATE_REQUEST,
  PURCHASE_ORDER_CREATE_SUCCESS,
  PURCHASE_ORDER_CREATE_FAILURE,
  PURCHASE_ORDER_UPDATE_REQUEST,
  PURCHASE_ORDER_UPDATE_SUCCESS,
  PURCHASE_ORDER_UPDATE_FAILURE,
  PURCHASE_ORDER_VOID_REQUEST,
  PURCHASE_ORDER_VOID_SUCCESS,
  PURCHASE_ORDER_VOID_FAILURE,
  PURCHASE_ORDER_MARK_COMPLETE_REQUEST,
  PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
  PURCHASE_ORDER_MARK_COMPLETE_FAILURE,
  PURCHASE_ORDER_STATUS_LIST_GET_REQUEST,
  PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS,
  PURCHASE_ORDER_STATUS_LIST_GET_FAILURE,
  PURCHASE_ORDER_STATUS_DATA_REQUEST,
  PURCHASE_ORDER_STATUS_DATA_SUCCESS,
  PURCHASE_ORDER_STATUS_DATA_FAILURE,
  PURCHASE_ORDER_STATUS_CREATE_REQUEST,
  PURCHASE_ORDER_STATUS_CREATE_SUCCESS,
  PURCHASE_ORDER_STATUS_CREATE_FAILURE,
  PURCHASE_ORDER_STATUS_UPDATE_REQUEST,
  PURCHASE_ORDER_STATUS_UPDATE_SUCCESS,
  PURCHASE_ORDER_STATUS_UPDATE_FAILURE,
  PURCHASE_ORDER_STATUS_DELETE_REQUEST,
  PURCHASE_ORDER_STATUS_DELETE_SUCCESS,
  PURCHASE_ORDER_STATUS_DELETE_FAILURE,
  PURCHASE_ORDER_PDF_REQUEST,
  PURCHASE_ORDER_PDF_SUCCESS,
  PURCHASE_ORDER_PDF_FAILURE,
} from "./actionType";

//initial state
const initialState = {
  purchaseOrderList: [],
  purchaseOrderListLoading: false,

  purchaseOrderSearch: [],
  purchaseOrderSearchLoading: false,

  purchaseOrderData: [],
  purchaseOrderDataLoading: false,

  purchaseOrderCreate: [],
  purchaseOrderCreateLoading: false,

  purchaseOrderUpdate: [],
  purchaseOrderUpdateLoading: false,

  purchaseOrderVoid: [],
  purchaseOrderVoidLoading: false,

  purchaseOrderMarkComplete: [],
  purchaseOrderMarkCompleteLoading: false,

  //status
  purchaseOrderStatusList: [],
  purchaseOrderStatusListLoading: false,

  purchaseOrderStatusData: [],
  purchaseOrderStatusDataLoading: false,

  purchaseOrderStatusCreate: [],
  purchaseOrderStatusCreateLoading: false,

  purchaseOrderStatusUpdate: [],
  purchaseOrderStatusUpdateLoading: false,

  purchaseOrderStatusDelete: [],
  purchaseOrderStatusDeleteLoading: false,

  purchaseOrderPdf: [],
  purchaseOrderPdfLoading: false,
};

//reducer
const PurchaseOrder = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_ORDER_LIST_GET_REQUEST:
      return {
        ...state,
        purchaseOrderListLoading: true,
      };
    case PURCHASE_ORDER_LIST_GET_SUCCESS:
      return {
        ...state,
        purchaseOrderList: action.payload,
        purchaseOrderListLoading: false,
      };
    case PURCHASE_ORDER_LIST_GET_FAILURE:
      return {
        ...state,
        purchaseOrderListLoading: false,
      };
    case PURCHASE_ORDER_SEARCH_REQUEST:
      return {
        ...state,
        purchaseOrderSearchLoading: true,
      };
    case PURCHASE_ORDER_SEARCH_SUCCESS:
      return {
        ...state,
        purchaseOrderSearch: action.payload,
        purchaseOrderSearchLoading: false,
      };
    case PURCHASE_ORDER_SEARCH_FAILURE:
      return {
        ...state,
        purchaseOrderSearchLoading: false,
      };
    case PURCHASE_ORDER_DATA_REQUEST:
      return {
        ...state,
        purchaseOrderDataLoading: true,
      };
    case PURCHASE_ORDER_DATA_SUCCESS:
      return {
        ...state,
        purchaseOrderData: action.payload,
        purchaseOrderDataLoading: false,
      };
    case PURCHASE_ORDER_DATA_FAILURE:
      return {
        ...state,
        purchaseOrderDataLoading: false,
      };
    case PURCHASE_ORDER_CREATE_REQUEST:
      return {
        ...state,
        purchaseOrderCreateLoading: true,
      };
    case PURCHASE_ORDER_CREATE_SUCCESS:
      return {
        ...state,
        purchaseOrderCreate: action.payload,
        purchaseOrderCreateLoading: false,
      };
    case PURCHASE_ORDER_CREATE_FAILURE:
      return {
        ...state,
        purchaseOrderCreateLoading: false,
      };
    case PURCHASE_ORDER_UPDATE_REQUEST:
      return {
        ...state,
        purchaseOrderUpdateLoading: true,
      };
    case PURCHASE_ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        purchaseOrderUpdate: action.payload,
        purchaseOrderUpdateLoading: false,
      };
    case PURCHASE_ORDER_UPDATE_FAILURE:
      return {
        ...state,
        purchaseOrderUpdateLoading: false,
      };
    case PURCHASE_ORDER_VOID_REQUEST:
      return {
        ...state,
        purchaseOrderVoidLoading: true,
      };
    case PURCHASE_ORDER_VOID_SUCCESS:
      return {
        ...state,
        purchaseOrderVoid: action.payload,
        purchaseOrderVoidLoading: false,
      };
    case PURCHASE_ORDER_VOID_FAILURE:
      return {
        ...state,
        purchaseOrderVoidLoading: false,
      };
    case PURCHASE_ORDER_MARK_COMPLETE_REQUEST:
      return {
        ...state,
        purchaseOrderMarkCompleteLoading: true,
      };
    case PURCHASE_ORDER_MARK_COMPLETE_SUCCESS:
      return {
        ...state,
        purchaseOrderMarkComplete: action.payload,
        purchaseOrderMarkCompleteLoading: false,
      };
    case PURCHASE_ORDER_MARK_COMPLETE_FAILURE:
      return {
        ...state,
        purchaseOrderMarkCompleteLoading: false,
      };
    //status
    case PURCHASE_ORDER_STATUS_LIST_GET_REQUEST:
      return {
        ...state,
        purchaseOrderStatusListLoading: true,
      };
    case PURCHASE_ORDER_STATUS_LIST_GET_SUCCESS:
      return {
        ...state,
        purchaseOrderStatusList: action.payload,
        purchaseOrderStatusListLoading: false,
      };
    case PURCHASE_ORDER_STATUS_LIST_GET_FAILURE:
      return {
        ...state,
        purchaseOrderStatusListLoading: false,
      };
    case PURCHASE_ORDER_STATUS_DATA_REQUEST:
      return {
        ...state,
        purchaseOrderStatusDataLoading: true,
      };
    case PURCHASE_ORDER_STATUS_DATA_SUCCESS:
      return {
        ...state,
        purchaseOrderStatusData: action.payload,
        purchaseOrderStatusDataLoading: false,
      };
    case PURCHASE_ORDER_STATUS_DATA_FAILURE:
      return {
        ...state,
        purchaseOrderStatusDataLoading: false,
      };
    case PURCHASE_ORDER_STATUS_CREATE_REQUEST:
      return {
        ...state,
        purchaseOrderStatusCreateLoading: true,
      };
    case PURCHASE_ORDER_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        purchaseOrderStatusCreate: action.payload,
        purchaseOrderStatusCreateLoading: false,
      };
    case PURCHASE_ORDER_STATUS_CREATE_FAILURE:
      return {
        ...state,
        purchaseOrderStatusCreateLoading: false,
      };
    case PURCHASE_ORDER_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        purchaseOrderStatusUpdateLoading: true,
      };
    case PURCHASE_ORDER_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        purchaseOrderStatusUpdate: action.payload,
        purchaseOrderStatusUpdateLoading: false,
      };
    case PURCHASE_ORDER_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        purchaseOrderStatusUpdateLoading: false,
      };
    case PURCHASE_ORDER_STATUS_DELETE_REQUEST:
      return {
        ...state,
        purchaseOrderStatusDeleteLoading: true,
      };
    case PURCHASE_ORDER_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        purchaseOrderStatusDelete: action.payload,
        purchaseOrderStatusDeleteLoading: false,
      };
    case PURCHASE_ORDER_STATUS_DELETE_FAILURE:
      return {
        ...state,
        purchaseOrderStatusDeleteLoading: false,
      };
    case PURCHASE_ORDER_PDF_REQUEST:
      return {
        ...state,
        purchaseOrderPdfLoading: true,
      };
    case PURCHASE_ORDER_PDF_SUCCESS:
      return {
        ...state,
        purchaseOrderPdf: action.payload,
        purchaseOrderPdfLoading: false,
      };
    case PURCHASE_ORDER_PDF_FAILURE:
      return {
        ...state,
        purchaseOrderPdfLoading: false,
      };
    default:
      return state;
  }
};

export default PurchaseOrder;
